import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  Dialog,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useEffect, useReducer, useState } from "react";
import PageLoading from "../../../components/Loading/PageLoading";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useLoading } from "../../../context/LodingContext";
import {
  allComplaints,
  deleteComplaints,
  manageComplaintsDateFilter,
  manageComplaintsDateFilterMange,
} from "./data";
import { MdChangeCircle } from "react-icons/md";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import DateFilter from "../../components/DateFilter";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateComplaintStatusDialog from "./UpdateComplaintStatus";
import RoleAccess from "../../function/RoleAccess";

const ManageComplaints = () => {
  const [filter, dispatch] = useReducer(
    manageComplaintsDateFilterMange,
    manageComplaintsDateFilter
  );
  const [mangeComplaintsData, setMangeComplaintsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(0);
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();

  //table data
  const mangeComplaintsListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Complaint ID",
        field: "complaintId",
        name: "complaintId",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 2,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Status",
        field: "status",
        name: "status",
        flex: 2,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Complaint Date",
        field: "complaintDate",
        name: "complaintDate",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: mangeComplaintsData.map((v, i) => ({
      sno: i + 1,
      id: v.complaintId,
      complaintId: v?.complaintId,
      customerName: v?.customerName,
      status: v?.status,
      complaintDate: v?.complaintDate,
      status: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                v?.status?.toLowerCase() == "open"
                  ? "#2196F3"
                  : v?.status?.toLowerCase() == "resolved"
                  ? "#FFC107"
                  : v?.status?.toLowerCase() == "closed"
                  ? "#4CAF50"
                  : "",
            }}
          >
            {v?.status}
          </Typography>
          {v?.status?.toLowerCase() == "open" ||
          v?.status?.toLowerCase() == "resolved" ? (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleDialogOpen(v.complaintId, v.status, false)}
            />
          ) : (
            <VisibilityIcon
              fontSize="small"
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleDialogOpen(v.complaintId, v.status, true)}
            />
          )}
        </Box>
      ),
      createdBy: v?.user?.employeeName,
      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Manage Complaints Screen"
            component="ViewComplaint"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate("/manage-complaints/form", {
                  state: { type: "view", rowId: v?.complaintId },
                })
              }
            />
          </RoleAccess>
          <RoleAccess
            modelName="Manage Complaints Screen"
            component="UpdateComplaint"
          >
            {value != 1 && value != 2 && (
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate("/manage-complaints/form", {
                    state: { type: "edit", rowId: v?.complaintId },
                  })
                }
              />
            )}
          </RoleAccess>
          <RoleAccess
            modelName="Manage Complaints Screen"
            component="DeleteComplaint"
          >
            {value != 1 && value != 2 && (
              <DeleteIcon
                fontSize="small"
                className="actionIcon"
                onClick={() => handleDelte(v?.complaintId)}
              />
            )}
          </RoleAccess>
        </div>
      ),
    })),
  };

  useEffect(() => {
    fetchFilterData();
  }, []);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedComplaint, setSelectedComplaint] = useState(null);

  //status change dialog open
  const handleDialogOpen = (complaintId, status, disabled) => {
    setSelectedComplaint({ complaintId, status, disabled });
    setDialogOpen(true);
  };

  //status change dialog close
  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedComplaint(null);
  };

  //status change api call
  const handleSubmit = async (complaintId, formValues) => {
    // Perform API call to update complaint status
    if (formValues) {
      setCirleLoading(true);
      try {
        const response = await fetch(BASEURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: `
            mutation UpdateComplaintStatus($input: UpdateComplaintStatusInput!) {
              updateComplaintStatus(input: $input) {
                success
                message
                complaint {
                  complaintId
                  status
                  resolutionDescription
                  resolutionDate
                  actionsTaken
                  customerSatisfaction
                  closedRemarks
                }
              }
            }
          `,
            variables: {
              input: {
                complaintId: complaintId,
                status: formValues.status.value,
                resolutionDescription: formValues.resolutionDescription,
                resolutionDate: formValues.resolutionDate,
                actionsTaken: formValues.actionsTaken,
                customerSatisfaction: formValues.customerSatisfaction,
                closedRemarks: formValues.closedRemarks,
              },
            },
          }),
        });

        const res = await response.json();

        if (res?.data?.updateComplaintStatus?.success) {
          Swal.fire({
            icon: "success",
            title: "Status Updated Successfully!",
            timer: 1500,
            showConfirmButton: false,
          }).then(callListFunction);
        } else {
          Swal.fire({
            icon: "error",
            title: "Update Failed",
            text:
              res?.data?.updateComplaintStatus?.message ||
              "Please try again later.",
          });
        }
      } catch (error) {
        console.error("Failed to update status:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An unexpected error occurred. Please try again.",
        });
      } finally {
        setCirleLoading(false);
        callListFunction();
      }
    }
    handleDialogClose();
  };

  // delete api call
  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteComplaints, {
            complaintId: id,
          });

          const success = res?.deleteComplaint?.success;
          const message = res?.deleteComplaint?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              callListFunction();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  //callback function
  const callListFunction = () => {
    const status =
      value == 0
        ? "Open"
        : value == 1
        ? "Resolved"
        : value == 2
        ? "Closed"
        : "";

    fetchFilterData(status, "", filter?.formDate, filter?.endDate);
  };

  //tab chnage
  const handleChange = async (event, newValue) => {
    setValue(newValue);
    const status =
      newValue == 0 ? "Open" : newValue == 1 ? "Resolved" : "Closed";
    fetchFilterData(status, "", filter?.formDate, filter?.endDate);
  };

  //filter onchange
  const handlefilterChange = (e, name) => {
    const status = value == 0 ? "Open" : value == 1 ? "Resolved" : "Closed";

    if (name == "formDate") {
      fetchFilterData(status, "", e?.target?.value, filter?.endDate);
    } else if (name == "endDate") {
      fetchFilterData(status, "", filter?.formDate, e?.target?.value);
    }
  };

  //reset filter
  const resetFilters = async () => {
    dispatch({ value: "", name: "formDate" });
    dispatch({ value: "", name: "endDate" });
    fetchFilterData();
  };

  //fetch api call
  const fetchFilterData = async (
    status = "Open",
    customerId = "",
    fromDate,
    toDate
  ) => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, allComplaints, {
        status: status,
        customerId: customerId,
        fromDate: fromDate || null,
        toDate: toDate || null,
      });

      setMangeComplaintsData(res?.allComplaints?.data);
    } catch (error) {
      setMangeComplaintsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  //excel download
  const exportToCSV = () => {
    const keysToExclude = ["id", "action", "user"];

    // Filter keys (headers)
    const headers = Object.keys(mangeComplaintsData[0]).filter(
      (key) => !keysToExclude.includes(key)
    );

    const csvHeader = headers.join(",") + "\n";

    // Build rows with only allowed keys
    const csvRows = mangeComplaintsData
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Manage Complaints.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show alert after a brief delay
    setTimeout(() => {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Manage Complaints Excel Download Successfully",
        showConfirmButton: true,
      });
    }, 500); // slight delay to allow download to trigger
  };

  return (
    <DashboardLayout>
      <Card>
        <Dialog open={dialogOpen}>
          <UpdateComplaintStatusDialog
            open={dialogOpen}
            onClose={handleDialogClose}
            onSubmit={handleSubmit}
            Id={selectedComplaint?.complaintId}
            val={selectedComplaint?.status}
            disabled={selectedComplaint?.disabled}
          />
        </Dialog>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Manage Complaints List
                  </MaterialTypography>
                </Stack>

                <Box
                  sx={{
                    width: "50%",
                    bgcolor: "background.paper",
                  }}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#2a9941",
                        color: "white",
                      },
                    }}
                    centered
                  >
                    <Tab label="Open" />
                    <Tab label="Resolved" />
                    <Tab label="Closed" />
                  </Tabs>
                </Box>
                <RoleAccess
                  modelName="Manage Complaints Screen"
                  component="CreateComplaint"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      navigate("/manage-complaints/form", {
                        state: { type: "add" },
                      })
                    }
                  >
                    Manage Complaints
                  </MaterialButton>
                </RoleAccess>
              </Stack>
              <Box
                sx={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "75%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <DateFilter
                    dispatch={dispatch}
                    filter={filter}
                    handlefilterChange={handlefilterChange}
                    resetFilters={resetFilters}
                  />
                </Box>
                <Box
                  sx={{
                    width: "25%",
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <RoleAccess
                    modelName="Manage Complaints Screen"
                    component="ExportComplaint"
                  >
                    {mangeComplaintsData?.length > 0 && (
                      <button
                        className="container-btn-file"
                        onClick={exportToCSV}
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                          marginRight: "20px",
                        }}
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Export File
                      </button>
                    )}
                  </RoleAccess>
                </Box>
              </Box>
            </>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={mangeComplaintsListTable?.rows}
            columns={mangeComplaintsListTable?.columns}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any To Do details. Click on the "Add To
                    Do" button to start adding To Do details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default ManageComplaints;
